import React from "react";
import { Typography } from "@material-ui/core";

import "./StickyBanner.css";
import { ewbConfig } from "config";

const StickyBanner = ({
  image = "",
  description = "description",
  link = "",
}) => {
  if (image === "") {
    return null;
  }

  const onClick = (): void => {
    if (link === "") {
      return;
    }
    window.open(link, "__blank");
  };

  return (
    <div
      className={`banner-root ${link !== "" ? "hoverable" : ""}`}
      onClick={onClick}
    >
      <img height={64} width="100%" src={`${ewbConfig.apiUrl}${image}`} />
      <div className="text-container center" style={{ height: "100%" }}>
        <Typography
          component="p"
          className={`${link === "" ? "font-config-plain" : "font-config"}`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};

export default StickyBanner;
